<template>
    <div class="md uploader"
        :class="[isDrop? 'is-drop': '']"
        @dragover.prevent="changeDropStatus(true)"
        @dragleave.prevent="changeDropStatus(false)"
        @mouseover="changeDropStatus(true)"
        @mouseout="changeDropStatus(false)"
        @drop.prevent="uploadByDrop"
        @click="uploadByClick"
    >
        <input
            ref="uploader"
            type="file"
            name="file"
            :accept="accept"
            :multiple="multiple"

            @change="uploadByChange"
        >
        <cpStatus
            v-if="accept"
            tag="div"
            themes="info"
            icon="warning"
            :text="accept"
        ></cpStatus>
        <ul
            v-if="files && files.length"
            class="list"
        >
            <template
                v-for="file in files"
            >
                <li
                    is="cpUploader"
                    :key="$okaTool.getUUID()"
                    :obj="file"

                    @sendEvent="receiveEvent"
                ></li>
            </template>
        </ul>
        <div
            v-else
            class="info"
        >
            <span>{{ $t('talk.alert.upload.method') }}</span>
        </div>
    </div>
</template>

<script>
    import cpUploader from '@/components/cpUploader'
    import cpStatus from '@/components/cpStatus'
    import cpLabel from '@/components/cpLabel'

    export default {
        components: {
            cpUploader,
            cpStatus,
            cpLabel,
        },
        props: {
            files: {
                require: true,
            },
            // validate: {
            //     type: String,
            //     require: false,
            //     default: '',
            // },
            accept: {
                type: String,
                require: false,
                default: '',
            },
            multiple: {
                type: Boolean,
                require: false,
                default: true,
            },
        },
        data: function(){

            return {
                isDrop: false
            }
        },
        methods: {
            changeDropStatus: function(booleam){
                this.isDrop = booleam;
            },
            uploadCore: function(files){
                let _multiple = this.multiple,
                    $files = files;

                if( !_multiple && files.length > 1 ) { //單檔

                    $files = {
                        0: files[0],
                        length: 1
                    }
                }

                this.changeDropStatus(false);

                this.$emit('sendEvent', 'uploadFile', $files);
            },
            uploadByChange: function(evt){
                this.uploadCore(evt.target.files);
            },
            uploadByClick: function(){
                this.$refs.uploader.click();
            },
            uploadByDrop: function(evt){
                this.uploadCore(evt.dataTransfer.files);
            },
        }
    }
</script>

<style scoped lang="scss">

    .cp.status.is-warning {

        + .info {
            margin-top: 40px;
        }
    }

    .md.uploader {
        $height: 26px;

        position: relative;
        min-height: 50vh;
        background-color: $light;
        padding: $interval-s;
        margin-top: $interval-m;
        // border-radius: $border-radius;
        transition: $transition;
        overflow: auto;

        &.is-drop {
            $type: map-get($colors, 'info');
            $background: map-get($type, 'background');
            $border-c: map-get($type, 'border');
            $text: map-get($type, 'text');

            background-color: $background;
            border-color: $border-c;

            .info {
                color: $text;
            }
        }
        
        .info {
            position: absolute;
            display: flex;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            align-items: center;
            justify-content: center;
            pointer-events: none;

            > span {
                text-align: center;
                font-size: $font-size-l;
                justify-items: center;

                &::before {
                    @extend %font-pseudo;
                    content: '\e2c3';
                    display: block;
                    position: relative;
                    font-size: 100px;
                    line-height: 100px;
                    opacity: $opacity-h;
                    animation-name: jump;
                    animation-duration: 600ms;
                    animation-timing-function: ease-in-out;
                    animation-iteration-count: infinite;
                    animation-direction: alternate;
                }

                @keyframes jump{

                    from{
                        top: 6px;
                    }
                    to{
                        top: -3px;
                    }
                }
            }
        }

        > input[type='file'] {
            display: none;
        }

        &::v-deep {

            /*ul*/.list {
                @extend %reset;

                > li {
                    display: inline-block;
                    position: relative;
                    width: 50%;
                    padding: $interval-s;
                    box-sizing: border-box;

                    @include media('mobile') {
                        display: block;
                        width: auto;
                    }

                    @each $key, $map in $colors {
                        $tx: map-get($map, 'text');
                
                        &.is-#{$key} {
                        
                            .div {
            
                                .label {
            
                                    .process {
                                        background-color: $tx;
                                        width: 100% !important;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .div {
                position: relative;
                padding: $interval-m;
                padding-bottom: $interval-m + $height;
                background-color: $white;
                // border-radius: $border-radius;
                box-shadow: 0 0 $interval-m $light-gray;

                &.is-hover {
                    transition: $transition;
                    cursor: pointer;

                    &:hover {
                        opacity: $opacity-m;
                    }
                }
            }

            /*ul*/.func {
                @extend %reset;
                position: absolute;
                top: $interval-m;
                right: $interval-m;
                
                $size: 30px;

                li {
                    
                    &.remove {

                        a {
                
                            &::after {
                                content: '\e5cd';
                            }
                        }
                    }
                }

                a {
                    width: $size - $interval-m * 2;
                    height: $size - $interval-m * 2;
                    line-height: $size - $interval-m * 2;
                    text-align: center;
                    opacity: $opacity-l;
                    color: inherit;
                    cursor: pointer;
                
                    &:hover {
                        opacity: 1;
                    }
                
                    &::after {
                        @extend %font-pseudo;
                        margin-right: 0;
                        font-size: $font-size-xxl;
                        transition: $transition;
                        line-height: 1;
                    }
                }
            }
            
            .essay {

                .caption {
                    $size: 30px;
                    
                    @extend %ellipsis;
                    padding-right: $size !important;
                    color: $major-color;
                    font-size: $font-size-l;
                }

                .label {
                    position: absolute;
                    left: $interval-s;
                    right: $interval-s;
                    bottom: $interval-s;
                    height: $height;
                    background-color: $gray;
                    // border-radius: $border-radius;
                    overflow: hidden;

                    .process {
                        $type: map-get($colors, 'info');
                        $text: map-get($type, 'text');

                        content: $content;
                        position: absolute;
                        top: 0;
                        left: 0;
                        bottom: 0;
                        background-color: $text;
                    }

                    .status {
                        position: absolute;
                        height: $height;
                        line-height: $height;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        text-align: center;
                        color: $white;
                    }
                }

                .size {

                }
            }
        }
    }
</style>
